export const GET_CONTEXT_ALL_REQUEST = 'GET_CONTEXT_ALL_REQUEST';
export const GET_CONTEXT_ALL_SUCCESS = 'GET_CONTEXT_ALL_SUCCESS';
export const GET_CONTEXT_ALL_ERROR = 'GET_CONTEXT_ALL_ERROR';
export const GET_CONTEXT_LIST_REQUEST = 'GET_CONTEXT_LIST_REQUEST';
export const GET_CONTEXT_LIST_SUCCESS = 'GET_CONTEXT_LIST_SUCCESS';
export const GET_CONTEXT_LIST_ERROR = 'GET_CONTEXT_LIST_ERROR';
export const ADD_CONTEXT_REQUEST = 'ADD_CONTEXT_REQUEST';
export const ADD_CONTEXT_SUCCESS = 'ADD_CONTEXT_SUCCESS';
export const ADD_CONTEXT_ERROR = 'ADD_CONTEXT_ERROR';
export const GET_CONTEXT_REQUEST = 'GET_CONTEXT_REQUEST';
export const GET_CONTEXT_SUCCESS = 'GET_CONTEXT_SUCCESS';
export const GET_CONTEXT_ERROR = 'GET_CONTEXT_ERROR';
export const UPDATE_CONTEXT_REQUEST = 'UPDATE_CONTEXT_REQUEST';
export const UPDATE_CONTEXT_SUCCESS = 'UPDATE_CONTEXT_SUCCESS';
export const UPDATE_CONTEXT_ERROR = 'UPDATE_CONTEXT_ERROR';
export const DELETE_CONTEXT_REQUEST = 'DELETE_CONTEXT_REQUEST';
export const DELETE_CONTEXT_SUCCESS = 'DELETE_CONTEXT_SUCCESS';
export const DELETE_CONTEXT_ERROR = 'DELETE_CONTEXT_ERROR';
export const UPDATE_CONTEXT_LIST_PAGINATION_OPTIONS =
  'UPDATE_CONTEXT_LIST_PAGINATION_OPTIONS';
export const SELECT_CONTEXT = 'SELECT_CONTEXT';
export const DESELECT_CONTEXT = 'DESELECT_CONTEXT';
export const UPDATE_CONTEXT_ALL = 'UPDATE_CONTEXT_ALL';

export const PARTIAL_EXPORT_CONTEXT_REQUEST = 'PARTIAL_EXPORT_CONTEXT_REQUEST';
export const PARTIAL_EXPORT_CONTEXT_COMPLETE =
  'PARTIAL_EXPORT_CONTEXT_COMPLETE';
export const PARTIAL_EXPORT_CONTEXT_CANCEL = 'PARTIAL_EXPORT_CONTEXT_CANCEL';

export const PARTIAL_IMPORT_CONTEXT_REQUEST = 'PARTIAL_IMPORT_CONTEXT_REQUEST';
export const PARTIAL_IMPORT_CONTEXT_COMPLETE =
  'PARTIAL_IMPORT_CONTEXT_COMPLETE';
export const PARTIAL_IMPORT_CONTEXT_CANCEL = 'PARTIAL_IMPORT_CONTEXT_CANCEL';
